import "./App.css";
import FirstPage from "./FirstPage/FirstPage";
import SecondPage from "./SecondPage/SecondPage";
import ThridPage from "./ThirdPage/ThridPage";
import ForthPage from "./ForthPage/ForthPage";


function App() {
  return (
    <>
      <FirstPage></FirstPage>
      <SecondPage></SecondPage>
      <ThridPage></ThridPage>
      <ForthPage></ForthPage>
    </>
  );
}

export default App;
